import React, { Fragment } from 'react';
import { Container, InfoContainer } from './ShowInfo.styles';
import { ShowInfoPlaceholder } from './ShowInfoPlaceholder';
import { ShowMoreText } from './ShowMoreText';
import { ShowTitle } from './ShowTitle';
import { useShowImageAndFrame } from './use-show-image-and-frame';
import { leadOrDescription } from '../../../../../play-core/utils/string-helper';
import { Breadcrumbs } from '../../../components/Breadcrumbs/Breadcrumbs';
import { isInternalLink } from '../../../components/ClickableComponents/PlayLink';
import { InfoLabel } from '../../../components/InfoLabel/InfoLabel';
import { useRoutes, useVideoConfig } from '../../../config/VideoAppContext';
import { ShowLinks } from '../ShowLinks/ShowLinks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowInfo = ({
  showDetail,
  topic
}) => {
  const {
    preferredShowDescription,
    baseUrl
  } = useVideoConfig();
  const routes = useRoutes();
  const {
    Frame,
    Image
  } = useShowImageAndFrame(showDetail);
  const links = showDetail?.links ?? [];
  const externalLinks = links.filter(link => !isInternalLink(routes, baseUrl, link.link));
  const description = preferredShowDescription === 'lead' ? leadOrDescription(showDetail) : showDetail?.description || showDetail?.lead;
  return /*#__PURE__*/_jsx(Fragment, {
    children: showDetail ? /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsxs(Container, {
        topicUrn: topic?.urn,
        children: [Frame, /*#__PURE__*/_jsxs(InfoContainer, {
          children: [/*#__PURE__*/_jsx(Breadcrumbs, {
            topic: topic
          }), /*#__PURE__*/_jsx(ShowTitle, {
            show: showDetail
          }), /*#__PURE__*/_jsx(InfoLabel, {
            text: showDetail.broadcastInformation?.hintText
          }), description && /*#__PURE__*/_jsx(ShowMoreText, {
            description: description,
            numberOfLines: externalLinks.length > 0 ? 3 : 5
          }), /*#__PURE__*/_jsx(ShowLinks, {
            links: externalLinks
          })]
        }), Image]
      })
    }) : /*#__PURE__*/_jsx(ShowInfoPlaceholder, {})
  });
};